import { render, staticRenderFns } from "./vdHeader.vue?vue&type=template&id=ff39c620&scoped=true&"
import script from "./vdHeader.vue?vue&type=script&lang=js&"
export * from "./vdHeader.vue?vue&type=script&lang=js&"
import style0 from "./vdHeader.vue?vue&type=style&index=0&id=ff39c620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../hastrid-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff39c620",
  null
  
)

export default component.exports